import {Observable} from 'rxjs/Observable';

// Classes.
import {ViewData} from './view-data';
import {AthleteGeneralInfoItem} from '../fetching/types/athlete-general-info.item';
import {DataContainer} from '../db/data-container';
import {ResponseData} from '../fetching/wa-response/wa-api-response';

// Providers.
import {LoggerService} from '../logger/logger-service';
import {DataFetchService} from '../wa-services/data-fetch-service';
import {DatabaseService} from '../wa-services/database-service';
import {FactoryService} from '../wa-services/factory-service';
import {WaHelperService} from '../wa-services/wa-helper-service';

// Interfaces.
import {LocatorInterface} from '../interfaces/locator.interface';
import {ViewDataConfigStruct} from '../interfaces/view-data.interface';
import {AthleteDatabaseServiceInterface} from '../interfaces/athlete-database-service.interface';


export class AthleteListVD extends ViewData<AthleteGeneralInfoItem> {

  constructor(
    protected logger: LoggerService,
    protected fetchSrvc: DataFetchService,
    protected db: DatabaseService,
    protected athDb: AthleteDatabaseServiceInterface,
    protected factory: FactoryService,
    protected _helper: WaHelperService,
    protected _locator: LocatorInterface
  ) {
    super(logger, db, _locator);
  }

  public configureView() {
    let viewDataConf = new ViewDataConfigStruct();
    // Max age: 6 month.
    viewDataConf.maxAge = 1800;
    viewDataConf.expectedItems = 100;
    this.applyConfiguration(viewDataConf);
  }

  public updateData(): Observable<ResponseData> {
    return this.fetchSrvc.requestAthleteList(this.pageInfo());
  }

  public mapItem(rawItem: any): AthleteGeneralInfoItem {
    let athleteItem = this.factory.newAthleteGeneralInfoItem(rawItem);
    return athleteItem;
  }

  public postMapItemsDataContainerProcess(dataContainer: DataContainer<AthleteGeneralInfoItem>) {
    this.athDb.storeList(dataContainer.getPayload())
  }
}
